import React, { Component } from 'react';
// import axios from 'axios';
import {get, post, put, del} from '../../DAL/Request'
import PropTypes from 'prop-types'
import { Select, Modal, Button, Form, Row, Col, Input, Switch } from 'antd';
import PicturesWall from './PicturesWall'
import config from '../../dummy_data/configuration.json';

import BraftEditor from 'braft-editor'
import 'braft-editor/dist/braft.css'

const FormItem = Form.Item;
const Option = Select.Option;

class NewsEditor extends Component {

	static propTypes = {
		visible: PropTypes.bool.isRequired,
		item: PropTypes.object.isRequired,
		handleShowHideModal: PropTypes.func.isRequired,
		handleUpdateImageUrl: PropTypes.func.isRequired,
		handleRefreshData: PropTypes.func.isRequired
	}

	constructor () {
		super()
		this.state = {
			loading: false,
			fileList: []
		}
	}

	componentWillReceiveProps(nextProps) {
		// console.log("componentWillReceiveProps: ", nextProps);
		if(nextProps.item.Thumbnail && nextProps.item.Thumbnail.length > 0){
			this.setState({ 
				fileList: [{
			      	uid: -1,
			      	name: 'timg.abafe8ea.jpg',
			      	status: 'done',
			      	// url: 'http://localhost:3000/static/media/timg.abafe8ea.jpg',
					url: nextProps.item.Thumbnail
			    }],
			});
		}
		else{
			this.setState({ 
				fileList: []
			});
		}

		if(this.editorInstance && (this.props.visible !== nextProps.visible)){
			this.editorInstance.setContent(nextProps.item.Content, 'html');
		}
	}

	// componentDidMount() {
	// 	//this.editorInstance.setContent(this.props.item.Content, 'html');
	// 	console.log(config);
	// }


	handleShowHideModal(visible){
		if(this.props.handleShowHideModal){
			this.props.handleShowHideModal(visible);
		}

		if(!visible){
			this.editorInstance.setContent('', 'html');
		}
		else{
			this.editorInstance.setContent(this.props.item.Content, 'html');
		}
	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			console.log(values);
			if (!err && this.state.fileList.length > 0) {
				this._saveFormValues(values);

				this.setState({ loading: true });
				setTimeout(() => {
				  	this.setState({ loading: false });
				  	this.handleShowHideModal(false);
				  	this._resetFormfields();
				}, 3000);
			}
			
			
		});
	}

	

	handleCancel = () => {
		this.handleShowHideModal(false);

		this._resetFormfields();
	}

	handleImageChange = ({ fileList }) => {
		// console.log(fileList);
		this.setState({ fileList });
		if(fileList.length > 0 && fileList[0].response !== undefined && this.props.handleUpdateImageUrl){
			this.props.handleUpdateImageUrl(config.rootSite + fileList[0].response);
		}
	}

	handleContentChange = (content) => {
		// console.log(this.editorInstance.getContent('raw'));
  	}

  	handleHTMLChange = (html) => {
	    // console.log(html)
	    this.setState({htmlContent: html});

	    this._getPlainText();
  	}

  	_getPlainText = () => {
  		let summary = [];
	    let {blocks} = this.editorInstance.getContent('raw');
	    blocks.forEach((item) => {
	    	if(item.text !== "a" && item.text !== ""){
	    		summary.push(item.text);
	    	}
	    })

	    console.log(summary.join(""));

	    return summary.join("");
  	}

  	//rich text box image uploading
  	handleUploadImg = (param) => {
    	console.log(param);

      	const formData = new FormData();
      	formData.append('file', param.file);

      	// axios({
       //    	method: 'post',
       //    	url: config.imageUploadAction,
       //    	responseType:'json',
       //    	data: formData
      	// }).then(res => {
       //    	console.log("response", res);

       //    	param.success({
       //        	url: config.rootSite + res.data
       //    	})
      	// }).catch(function (error) {
       //    	console.log(error);
      	// });
      	post({
  			url: config.imageUploadAction, 
  			history: this.props.history,
  			body: formData,
  			callback: (res) => {
  				console.log("response", res);
	          	param.success({
	              	url: config.rootSite + res.data
	          	})
  			}
  		});
  	}

  	handlePreview = () => {
	    if (window.previewWindow) {
	      	window.previewWindow.close()
	    }
	    window.previewWindow = window.open()
	    window.previewWindow.document.write(this.buildPreviewHtml())
  	}

  	buildPreviewHtml () {

	    const htmlContent = this.editorInstance.getHTMLContent()

	    return `
	      	<!Doctype html>
	      	<html>
	        	<head>
		          	<title>内容预览</title>
		          	<style>
		            	html,body{
		              		height: 100%;
		              		margin: 0;
		              		padding: 0;
		              		overflow: auto;
		              		background-color: #f1f2f3;
		            	}
		            	.container{
			              	box-sizing: border-box;
			              	width: 1000px;
			              	max-width: 100%;
			              	min-height: 100%;
			              	margin: 0 auto;
			              	padding: 30px 20px;
			              	overflow: hidden;
			              	background-color: #fff;
			              	border-right: solid 1px #eee;
			              	border-left: solid 1px #eee;
		            	}
		            	.container img,
		            	.container audio,
		            	.container video{
		              		max-width: 100%;
		              		height: auto;
		            	}
		          	</style>
	        	</head>
		        <body>
		            <div class="container">${htmlContent}</div>
		        </body>
	      	</html>
    	`

  	}

  	handleMenuClick = (e) => {
	  	console.log('click', e);
	}

  	_saveFormValues = (values) => {
		values.ID = this.props.item.ID;
		values.Thumbnail = this.state.fileList[0].url;	
		values.Content = this.editorInstance.getHTMLContent();
		values.PlainText = this._getPlainText();
		values.Created = this.props.item.Created;
		values.Modified = this.props.item.Modified;
		console.log('Received values of form: ', values);

		let method = values.ID > 0? 'put' : 'post';
		let url = values.ID > 0? `${config.newsItemsAction}/${values.ID}` : config.newsItemsAction;

		// axios({
		// 	method: method,
		// 	url: url,
		// 	responseType:'json',
		// 	data: values
		// }).then(res => {
		// 	console.log("response", res);
		// 	if(this.props.handleRefreshData){
		// 		this.props.handleRefreshData();
		// 	}
		// }).catch(function (error) {
		// 	console.log(error);
		// });
		if(values.ID > 0){
			put({
	  			url: `${config.newsItemsAction}/${values.ID}`, 
	  			history: this.props.history,
	  			body: values,
	  			callback: (res) => {
	  				console.log("response", res);
					if(this.props.handleRefreshData){
						this.props.handleRefreshData();
					}
	  			}
	  		});
		}
		else{
			post({
	  			url: config.newsItemsAction, 
	  			history: this.props.history,
	  			body: values,
	  			callback: (res) => {
	  				console.log("response", res);
					if(this.props.handleRefreshData){
						this.props.handleRefreshData();
					}
	  			}
	  		});
		}
	}

  	_resetFormfields = () => {
  		//this is so important, if miss, form fields will always keep the same values as the submitted values.
		this.props.form.resetFields();

		this.setState({ fileList: [] });
  	}

	render() {
		const { getFieldDecorator } = this.props.form;
		const { ID, NewsType, Title, Content, Available } = this.props.item;
		const editorProps = {
			height: 500,
      		contentFormat: 'html',
	      	initialContent: Content,
	      	onChange: this.handleContentChange,
      		onHTMLChange: this.handleHTMLChange,
      		media:{
        		image: true,
		        video: false,
		        audio: false,
		        validateFn: null,
		        uploadFn: this.handleUploadImg
      		},
      		extendControls: [
	        	{
	            	type: 'split',
	          	},
	          	{
		            type: 'button',
		            text: 'Preview',
		            className: 'preview-button',
		            onClick: this.handlePreview
	          	}
      		]
		}

		return (
			<Modal className="news-form-modal" width={1000} visible={this.props.visible} title={ID > 0? 'Edit news item': 'Add news item'} onCancel={this.handleCancel} footer={[
	            <Button key="back" onClick={this.handleCancel}>Cancel</Button>,
	            <Button key="submit" type="primary" loading={this.state.loading} onClick={this.handleSubmit}>
	              Submit
	            </Button>
          	]}>
	          	<Form className="news-form">
		          	<Row>
			        	<Col span={12} style={{ textAlign: 'left' }}>
				        	<FormItem label="Title">
								{
									getFieldDecorator(
										'Title', 
										{ initialValue: Title, rules: [{ required: true, message: 'Please input title!' }],}
									)(
										<Input placeholder="Title" />
									)
								}
					        </FormItem>
					        <Row>
					        	<Col span={12}>
					        		<FormItem label="News Type">
										{
											getFieldDecorator(
												'NewsType', 
												{ initialValue: NewsType, rules: [{ required: true, message: 'Please input news type!' }] }
											)(
												<Select>
										        	<Option value="Enterprise">Enterprise</Option>
          											<Option value="Industry">Industry</Option>
										        </Select>
											)
										}
							        </FormItem>
					        	</Col>
					        	<Col span={2}></Col>
					        	<Col span={10}>
							        <FormItem label="Available">
										{
											getFieldDecorator('Available', { initialValue: Available, valuePropName: 'checked' })(
												<Switch />
											)
										}
							        </FormItem>
							    </Col>
					        </Row>
				        </Col>
				        <Col span={2}></Col>
				        <Col span={10} style={{ textAlign: 'left' }}>
					        <FormItem label="Thumbnail(260*156)" className="news-thumbnail">
					          	<PicturesWall fileList={this.state.fileList} uploadAction={config.imageUploadAction} handleImageChange={this.handleImageChange}/>
					        </FormItem>
				        </Col>
			        </Row>
			        <BraftEditor ref={instance => this.editorInstance = instance} {...editorProps}/>
		        </Form>
	        </Modal>
		);
	}
}

const NewsEditorForm = Form.create()(NewsEditor);

export default NewsEditorForm;


// WEBPACK FOOTER //
// ./src/components/admin/NewsEditorForm.js